import React, { useEffect, useState } from 'react'
import ErrorPage from './components/error/ErrorPage'
import BaseMap from './components/Map/BaseMap'

import config from './config/BaseMapConfig'

function App() {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const [prognoseFogHeights, setPrognoseFogHeights] = useState(null)
  const [lastUpdated, setLastUpdated] = useState(null)
  const [date, setDate] = useState(today)
  const [usePrognose, setUsePrognose] = useState(true)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    fetch(config.fog_heights_url)
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.json()
      })
      .then((data) => {
        /* 
        Setting up Prognose Fog Heights
        */
        setPrognoseFogHeights({
          'alpen-voralpen': {
            fog_today: data.included_regions['alpen-voralpen'].fog_today,
            fog_tomorrow: data.included_regions['alpen-voralpen'].fog_tomorrow,
            fog_day_after_tomorrow: data.included_regions['alpen-voralpen'].fog_day_after_tomorrow,
            fog_info_today: data.included_regions['alpen-voralpen'].fog_info_today,
            fog_info_tomorrow: data.included_regions['alpen-voralpen'].fog_info_tomorrow,
            fog_info_day_after_tomorrow: data.included_regions['alpen-voralpen'].fog_info_day_after_tomorrow,
          },
          ostschweiz: {
            fog_today: data.included_regions.ostschweiz.fog_today,
            fog_tomorrow: data.included_regions.ostschweiz.fog_tomorrow,
            fog_day_after_tomorrow: data.included_regions.ostschweiz.fog_day_after_tomorrow,
            fog_info_today: data.included_regions.ostschweiz.fog_info_today,
            fog_info_tomorrow: data.included_regions.ostschweiz.fog_info_tomorrow,
            fog_info_day_after_tomorrow: data.included_regions.ostschweiz.fog_info_day_after_tomorrow,
          },
          tessin: {
            fog_today: data.included_regions.tessin.fog_today,
            fog_tomorrow: data.included_regions.tessin.fog_tomorrow,
            fog_day_after_tomorrow: data.included_regions.tessin.fog_day_after_tomorrow,
            fog_info_today: data.included_regions.tessin.fog_info_today,
            fog_info_tomorrow: data.included_regions.tessin.fog_info_tomorrow,
            fog_info_day_after_tomorrow: data.included_regions.tessin.fog_info_day_after_tomorrow,
          },
          westschweiz: {
            fog_today: data.included_regions.westschweiz.fog_today,
            fog_tomorrow: data.included_regions.westschweiz.fog_tomorrow,
            fog_day_after_tomorrow: data.included_regions.westschweiz.fog_day_after_tomorrow,
            fog_info_today: data.included_regions.westschweiz.fog_info_today,
            fog_info_tomorrow: data.included_regions.westschweiz.fog_info_tomorrow,
            fog_info_day_after_tomorrow: data.included_regions.westschweiz.fog_info_day_after_tomorrow,
          },
        })

        setLastUpdated(data.included_regions['alpen-voralpen'].last_modified)
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.error(e)
        setError(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  if (loading) {
    return null
  }

  if (error || prognoseFogHeights === null) {
    return <ErrorPage />
  }

  return (
    <div className="Map-container">
      <BaseMap
        prognoseFogHeights={prognoseFogHeights}
        setPrognoseFogHeights={setPrognoseFogHeights}
        date={date}
        setDate={setDate}
        lastUpdated={lastUpdated}
        usePrognose={usePrognose}
        setUsePrognose={setUsePrognose}
      />
    </div>
  )
}

export default App
